import React from 'react';

export default function CapabilityCard({ project = null }) {
  if (!project || typeof project !== 'object') return null;

  const {
    title = 'Untitled',
    catchPhrase = '',
    description = '',
    imageClass = '',   // CSS로 관리하는 썸네일 클래스
    image = '',        // (호환용) 개별 이미지 경로를 쓰는 경우
    url = '',          // (선택) 외부 링크가 있는 경우
  } = project;

  return (
    <article className="card card-col-4 cap-card">
      {/* CSS 기반 썸네일 */}
      {imageClass && <div className={`cap-thumb ${imageClass}`} aria-hidden="true" />}

      {/* 과거 방식(이미지 경로 직접)도 지원 */}
      {!imageClass && image && (
        <img className="cap-img" src={image} alt={title} loading="lazy" />
      )}

      <h3 className="capability-title">{title}</h3>
      {catchPhrase && <p className="cap-catch">{catchPhrase}</p>}
      {description && <p className="cap-desc">{description}</p>}

      {url && (
        <p className="cap-link">
          <a href={url} target="_blank" rel="noreferrer">View</a>
        </p>
      )}
    </article>
  );
}
